var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.type, {
    tag: "component",
    class: _vm.gtmClassName,
    attrs: {
      data: _vm.updatedDetails,
      source: _vm.source,
      downloadsource: _vm.downloadsource,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }